import React from 'react';
import { styled } from 'styled-components';
import SvgChevron from '../../../../../play-core/icons/Chevron';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { ellipsis } from '../../../../../play-core/styles/style-helper';
import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileFilterMenuItem = ({
  title,
  text,
  isEnabled,
  onClick
}) => /*#__PURE__*/_jsx(StyledMenuItem, {
  onClick: () => isEnabled && onClick(),
  isEnabled: isEnabled,
  children: /*#__PURE__*/_jsxs(MenuItemContent, {
    children: [/*#__PURE__*/_jsxs(MenuItemText, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: title
      }), text && /*#__PURE__*/_jsx(Text, {
        children: text
      })]
    }), /*#__PURE__*/_jsx(IconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: "right"
      })
    })]
  })
});
const StyledMenuItem = styled.button.withConfig({
  displayName: "MobileFilterMenuItem__StyledMenuItem",
  componentId: "sc-k8kisu-0"
})(["min-height:56px;width:100%;padding:0 24px;color:", ";background-color:", ";text-transform:none;text-align:left;&:active{background-color:", ";}"], props => props.isEnabled ? Colors.GREY_d2d2d2 : Colors.GREY_969696, Colors.GREY_1a1a1a, Colors.GREY_222222);
const MenuItemContent = styled.div.withConfig({
  displayName: "MobileFilterMenuItem__MenuItemContent",
  componentId: "sc-k8kisu-1"
})(["display:flex;justify-content:space-between;"]);
const MenuItemText = styled.div.withConfig({
  displayName: "MobileFilterMenuItem__MenuItemText",
  componentId: "sc-k8kisu-2"
})(["display:flex;flex-direction:column;overflow:hidden;padding:16px 16px 16px 0;"]);
const Title = styled.span.withConfig({
  displayName: "MobileFilterMenuItem__Title",
  componentId: "sc-k8kisu-3"
})(["", ";", ";"], Fonts.regular(16), ellipsis);
const Text = styled.span.withConfig({
  displayName: "MobileFilterMenuItem__Text",
  componentId: "sc-k8kisu-4"
})(["", ";color:", ";padding-top:4px;", ";"], Fonts.regular(14), Colors.GREY_969696, ellipsis);